import { render } from "./Dashboard.vue?vue&type=template&id=ba010776"
import script from "./Dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./Dashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Lockstep/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba010776"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba010776', __exports__)) {
    api.reload('ba010776', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=ba010776", () => {
    api.rerender('ba010776', render)
  })

}


export default __exports__